var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoringIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 2.5C15.0002 1.12033 16.1206 0 17.5002 0C18.8799 0 20.0002 1.12033 20.0002 2.5C20.0002 3.87967 18.8799 5 17.5002 5C16.1206 5 15.0002 3.87967 15.0002 2.5ZM13.0002 2.5C13.0002 2.33101 13.0096 2.16419 13.0278 2.00001L5.401 2.00003C2 2.00003 0 4.02003 0 7.42003V14.5993C0 17.9903 2 20.0003 5.401 20.0003H12.6002C16.0002 20.0003 18.0002 17.9903 18.0002 14.5993V6.97248C17.8361 6.99066 17.6692 7 17.5002 7C15.0168 7 13.0002 4.9834 13.0002 2.5ZM13.7529 9.65854C14.1165 9.24291 14.0744 8.61115 13.6588 8.24746C13.2432 7.88378 12.6114 7.9259 12.2477 8.34154L10.3322 10.6735L8.61377 9.49816C7.74124 8.90137 6.55496 9.08665 5.90596 9.92107L4.21094 12.3861C3.87187 12.822 3.9504 13.4503 4.38635 13.7894C4.8223 14.1285 5.45057 14.0499 5.78964 13.614L7.48466 11.149L9.2031 12.3243C10.039 12.8961 11.1704 12.7527 11.8374 11.9905L13.7529 9.65854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoringIconDark);
export default __webpack_public_path__ + "static/media/ScoringIconDark.69e03bb65878c26f72d340efc5f71fa4.svg";
export { ForwardRef as ReactComponent };